<div class="container px-2 pb-3 main-container">
    <div class="row row-xs">

        <div class="col-6 col-sm- col-md-3">
            <div class="form-col">
                <label class="mb-1">{{ 'report.DATE_FROM' | translate }}</label>
                <div>
                    <app-datepicker [(model)]="filters.dateFrom"></app-datepicker>
                </div>
            </div>
        </div>
        <div class="col-6 col-sm- col-md-3">
            <div class="form-col">
                <label class="mb-1 block">{{ 'report.DATE_TO' | translate }}</label>
                <div>
                    <app-datepicker [(model)]="filters.dateTo"></app-datepicker>
                </div>
            </div>
        </div>
        <div class="col-12 col-sm-6 col-md-3">
            <div class="row row-xs">
                <div class="col-6">
                    <div class="form-col">
                        <label class="mb-1">{{ 'report.TIME_FROM' | translate }}</label>
                        <app-dropdown [(model)]="filters.timeFrom" [items]="times" [displayProperty]="'display'"
                            [valueProperty]="'value'">
                        </app-dropdown>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-col">
                        <label class="mb-1">{{ 'report.TIME_TO' | translate }}</label>
                        <app-dropdown [(model)]="filters.timeTo" [items]="times" [displayProperty]="'display'"
                            [valueProperty]="'value'">
                        </app-dropdown>
                    </div>
                </div>
            </div>
        </div>


        <div class="col-12 col-sm-6 col-md-3">
            <div class="row row-xs">
                <div class="col-6">
                    <div class="form-col">
                        <label class="mb-1">{{ 'report.COVERS_FROM' | translate }}</label>
                        <app-dropdown [(model)]="filters.coversFrom" [items]="coversFrom" [displayProperty]="'display'"
                            [valueProperty]="'value'">
                        </app-dropdown>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-col">
                        <label class="mb-1">{{ 'report.COVERS_TO' | translate }}</label>
                        <app-dropdown [(model)]="filters.coversTo" [items]="covers" [displayProperty]="'display'"
                            [valueProperty]="'value'">
                        </app-dropdown>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-6 col-sm-6 col-md-3">
            <div class="form-col">
                <label class="mb-1">{{ 'report.VISIT_TYPE' | translate }}</label>
                <div class="dropdown ihost-dropdown ihost-replace-val">
                    <app-dropdown [(model)]="filters.visitType" [items]="visitTypes" [displayProperty]="'display'"
                        [valueProperty]="'instance'" [nestProperty]="'depth'">
                    </app-dropdown>
                </div>
            </div>
        </div>

        <div class="col-6 col-sm-6 col-md-3">
            <div class="form-col">
                <label class="mb-1">{{ 'report.CUSTOMER_TYPE' | translate }}</label>
                <app-dropdown [(model)]="filters.customerType" [items]="customerTypes" [displayProperty]="'display'"
                    [valueProperty]="'value'">
                </app-dropdown>
            </div>
        </div>

        <div class="col-6 col-sm-6 col-md-3">
            <div class="form-col">
                <label class="mb-1">{{ 'report.PURPOSE' | translate }}</label>
                <app-dropdown [(model)]="filters.purpose" [items]="purposes" [displayProperty]="'display'"
                    [valueProperty]="'value'">
                </app-dropdown>
            </div>
        </div>

        <div class="col-6 col-sm-6 col-md-3">
            <div class="form-col">
                <label class="mb-1">{{ 'report.EXTRA_INFO' | translate }}</label>
                <app-dropdown [(model)]="filters.extraInfo" [items]="extraInfos" [displayProperty]="'display'"
                    [valueProperty]="'value'">
                </app-dropdown>
            </div>
        </div>
        <div class="col-12 col-sm-6 col-md-3 mt-2">
            <button class="btn btn-main w-100" (click)="fetch()">{{ 'report.BTN_CREATE_REPORT' | translate }}</button>
        </div>
        <!--<div class="col-12 col-sm-6 col-md-3 mt-1 mt-sm-2">
            <button class="btn btn-sec bg-white w-100">{{ 'report.BTN_EXPORT_REPORT' | translate }}</button>
        </div>-->
    </div>
</div>

<div class="container px-2 mt-4 pb-5">
    <div class="row row-xs">
        <div class="col-12 col-lg-7 d-none d-md-block">
            <div class="p-4" style="width:100%;background:#fff;border-radius:5px;border:1px solid #e9e9ea;">
                <canvas *ngIf="hasMadeRequest" #chart baseChart [data]="barChartData" [options]="barChartOptions"
                    [type]="'bar'">
                </canvas>
            </div>
        </div>
        <div class="col-12 col-lg-5">
            <div class="box p-4 mt-2 mt-md-0 h-md-100">
                <table class="ihost-table" *ngIf="hasMadeRequest">
                    <thead>
                        <tr>
                            <th>{{ 'report.table.col_status' | translate }}</th>
                            <th>{{ 'report.table.col_people' | translate }}</th>
                            <th>{{ 'report.table.col_resvs' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{{ 'report.status.completed' | translate }}</td>
                            <td>{{ reportData.completedCovers }}</td>
                            <td>{{ reportData.completedReservations }}</td>
                        </tr>
                        <tr>
                            <td>{{ 'report.status.cancelled' | translate }}</td>
                            <td>{{ reportData.cancelledCovers }}</td>
                            <td>{{ reportData.cancelledReservations }}</td>
                        </tr>
                        <tr>
                            <td>{{ 'report.status.notshown' | translate }}</td>
                            <td>{{ reportData.noShowCovers }}</td>
                            <td>{{ reportData.noShowReservations }}</td>
                        </tr>
                        <tr>
                            <td>{{ 'report.status.upcoming' | translate }}</td>
                            <td>{{ reportData.upcomingCovers }}</td>
                            <td>{{ reportData.upcomingReservations }}</td>
                        </tr>
                        <tr>
                            <td>{{ 'report.status.rejected' | translate }}</td>
                            <td>{{ reportData.rejectedCovers }}</td>
                            <td>{{ reportData.rejectedReservations }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

</div>

<ngx-spinner name="report_spinner" type="square-jelly-box" [fullScreen]="true">
    <p style="color: white"> Loading... </p>
</ngx-spinner>